import { useSelector } from 'react-redux';
import { useInstoreServiceSlice } from './use-instore-service-slice';
import { selectPageModelCategoryId } from '../../../../store/pageModel';
import { selectIsSmallScreen } from '../../../../store/pageStore';
import { selectServices } from '../selectors';
import { Texts } from '../texts';

export const useInstoreService = () => {
	useInstoreServiceSlice();
	const categoryId = useSelector(selectPageModelCategoryId);
	const services = useSelector(selectServices);

	const isSmallScreen = useSelector(selectIsSmallScreen);

	const pageTexts = Texts[categoryId];

	return { categoryId, services, pageTexts, isSmallScreen };
};
